import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow, TextField } from "@mui/material";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import TablePaginationComponent from "../../../components/TablePagination";
import styles from "./paymentreports.module.css";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import { Calendar, Home, Search } from "react-feather";
import { DateRangePicker } from "rsuite";
import { Close } from "@mui/icons-material";
import { TableLoader } from "../../../components/ContentLoader";
import { useEffect, useState } from "react";
import axios from "axios";
import dayjs from "dayjs";
import { CurrencyFormatter } from "../../../components/Helpers";

const PaymentReports = () => {
    const auth = authData();
    const API_TOKEN = auth?.api_token;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [allData, setAllData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [searchKey, setSearchKey] = useState('');
    const [filterDate, setFilterDate] = useState(null);
    const [contentLoading, setContentLoading] = useState(true);

    const paginationChangePage = (event, newPage) => {
        setPage(newPage);
    }

    const paginationChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    }

    useEffect(() => {
        fetchOrders();
    }, [page, rowsPerPage]);

    useEffect(() => {
        if (page === 0) {
            fetchOrders();
        } else {
            setPage(0);
        }
    }, [searchKey, filterDate]);

    const fetchOrders = () => {
        axios.get(process.env.REACT_APP_API_URL + "v1/report/payment-histroies", {
            headers: {
                Authorization: `Bearer ${API_TOKEN}`,
            },
            params: {
                page: page + 1,
                per_page: rowsPerPage,
                search: searchKey,
                start_date: filterDate ? dayjs(filterDate[0]).format("YYYY-MM-DD") : null,
                end_date: filterDate ? dayjs(filterDate[1]).format("YYYY-MM-DD") : null,
            }
        }).then((response) => {
            setContentLoading(false);

            setAllData(response.data.data.data);
            setTotalCount(response.data.data.total);
        }).catch(() => {
            setContentLoading(false);
        });
    }

    return (<>
        <div className={`${styles.MainDiv}`}>
            <div className={`${styles.MainCard}`}>
                {contentLoading && <TableLoader />}

                {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
                    <p className={`${styles.PageTitle}`}>Payment Reports</p>
                    <nav aria-label="breadcrumb">
                        <ol className={`${styles.breadcrumb}`}>
                            <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Reports</li>
                            <li className={`${styles.breadcrumbItem} ${styles.active}`}>Payment Reports</li>
                        </ol>
                    </nav>
                </div>)}
                {!contentLoading && (<>
                    <div className={`${styles.TableFilterHead}`}>
                        <div className={`${styles.DataTableSearch}`}>
                            <Search className={`${styles.SearchIcon}`} />
                            <TextField id="search" type="text" placeholder="Search" aria-label="Search Input" value={searchKey} onChange={(e) => setSearchKey(e.target.value)} />
                            {searchKey !== "" && (<Button type="button" className={`${styles.CloseBU}`} onClick={(e) => setSearchKey("")}><Close /></Button>)}
                        </div>
                        <div className={`${styles.FilterCard}`}>
                            <div className={`${styles.DashFilterSec}`}>
                                <DateRangePicker format={"dd/MM/yyyy"} placement={"bottomEnd"} placeholder="Search by date" caretAs={Calendar} value={filterDate} showOneCalendar onChange={(e) => setFilterDate(e)} />
                            </div>
                        </div>
                    </div>

                    <div className={`${styles.CusTable}`}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <StyledMainTableCell>Booking Id</StyledMainTableCell>
                                        <StyledMainTableCell>Booking Created By</StyledMainTableCell>
                                        <StyledMainTableCell>Paid Amount</StyledMainTableCell>
                                        <StyledMainTableCell>Payment Notes</StyledMainTableCell>
                                        <StyledMainTableCell>Payment Added By</StyledMainTableCell>
                                        <StyledMainTableCell>Payment Date</StyledMainTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {allData.map((item, index) => {
                                        return (<StyledMainTableRow key={index} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                            <TableCell component="th" scope="row">{item?.booking_id_str}</TableCell>
                                            <TableCell component="th" scope="row">{item?.created_by}</TableCell>
                                            <TableCell component="th" scope="row">{CurrencyFormatter(parseFloat(item?.amount))}</TableCell>
                                            <TableCell component="th" scope="row">{item?.note}</TableCell>
                                            <TableCell component="th" scope="row">{item?.payment_added_by}</TableCell>
                                            <TableCell component="th" scope="row">{dayjs(item?.created_at).format('DD/MM/YYYY')}</TableCell>
                                        </StyledMainTableRow>);
                                    })}

                                    {allData.length === 0 && (<TableRow>
                                        <TableCell colSpan={6} align="center">No data found</TableCell>
                                    </TableRow>)}

                                </TableBody>
                                {totalCount > 0 && (<TableFooter>
                                    <TableRow>
                                        <TablePaginationComponent
                                            count={totalCount}
                                            colSpan={6}
                                            page={page}
                                            rowsPerPage={rowsPerPage}
                                            handleChangePage={paginationChangePage}
                                            handleChangeRowsPerPage={paginationChangeRowsPerPage}
                                        />
                                    </TableRow>
                                </TableFooter>
                                )}
                            </Table>
                        </TableContainer>
                    </div>
                </>)}
            </div>
        </div>
    </>);
};

export default withAdminAuth(PaymentReports);